// extracted by mini-css-extract-plugin
export default {"pricingPage":"PricingPage_pricingPage__EPLcd"};